import { useDispatch } from "react-redux";
import { openPopup } from "../../../store/popupSlice"

export default function LandingItalyMarket({data}) {
  const dispatch = useDispatch();
  return (
    <>
      <section className="land2-market">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="land2-market-details">
                <div className="row">
                  <div className="col-lg-7 col-xl-5">
                    <label>take action</label>
                    <h3 className="heading"><span> {data.titlePart1}   </span> {data.titlePart2}</h3>
                    <p>{data.desc}</p>
                    <button onClick={() => dispatch(openPopup())} className="default-white">{data.cta}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
